const pointType = {
	START: 1,
	END: 2,
	UNORIENTED: 4,
    TRANSIT: 8,
}

export default pointType;
